import React from 'react';

const ConfidentialitePage = () => {
  return (
    <div className="min-h-screen bg-[#FDFAF4] pb-16">
      <div className="max-w-4xl mx-auto px-6 py-16">
        <div className="text-center mb-12">
          <p className="text-xs uppercase tracking-[0.3em] text-[#B8922A] mb-4">
            Protection des données — RGPD
          </p>
          <h1
            className="text-5xl md:text-6xl font-light mb-4 text-[#5C2018]"
            style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}
            data-testid="confidentialite-title"
          >
            Politique de confidentialité
          </h1>
          <p className="text-[#332724]/70 font-light text-sm">
            Dernière mise à jour : juin 2026
          </p>
        </div>

        <div className="bg-white p-8 md:p-12 rounded-2xl border border-gold space-y-10 text-[#332724] font-light leading-relaxed">
          <section>
            <p className="text-sm">
              La SASU MAISON HARMONY (ci-après « Harmony Parfumerie ») accorde une grande
              importance à la protection de vos données personnelles. La présente politique
              décrit comment nous collectons, utilisons et protégeons vos informations
              conformément au Règlement Général sur la Protection des Données
              (Règlement UE 2016/679 — RGPD) et à la loi Informatique et Libertés.
            </p>
          </section>

          {/* Responsable traitement */}
          <section data-testid="section-responsable">
            <h2 className="text-2xl mb-4 text-[#5C2018]" style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}>
              1. Responsable du traitement
            </h2>
            <div className="text-sm space-y-1">
              <p><strong className="text-[#5C2018]">MAISON HARMONY</strong> — SASU au capital de 100 €</p>
              <p>Polygone Béziers, Local 221, Avenue Président Wilson, 34500 Béziers</p>
              <p>RCS Montpellier B 928 654 946 — SIRET 928 654 946 00013</p>
              <p>Contact : <a href="mailto:contact@maisonharmony.com" className="text-[#1E7A6A] hover:underline">contact@maisonharmony.com</a></p>
              <p>Représentée par Madame Hayat BOUSDIRA, Présidente</p>
            </div>
          </section>

          {/* Données collectées */}
          <section data-testid="section-donnees">
            <h2 className="text-2xl mb-4 text-[#5C2018]" style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}>
              2. Données collectées
            </h2>
            <p className="text-sm mb-3">
              Nous collectons uniquement les données strictement nécessaires aux services
              proposés. Selon votre interaction avec notre site, ces données peuvent inclure :
            </p>
            <ul className="text-sm space-y-2 list-disc pl-6">
              <li><strong>Formulaire de contact</strong> : nom, email, téléphone, message</li>
              <li><strong>Formulaire diagnostic olfactif</strong> : nom, email, préférences, message</li>
              <li><strong>Formulaire rendez-vous</strong> : nom, email, téléphone, date, service souhaité</li>
              <li><strong>Formulaire événements / partenariats</strong> : nom, email, téléphone, type d'événement, date, nombre de personnes, message</li>
              <li><strong>Avis clients</strong> : prénom, note, témoignage</li>
              <li><strong>Navigation</strong> : adresse IP, type de navigateur, pages visitées (logs serveur anonymisés)</li>
            </ul>
          </section>

          {/* Finalités */}
          <section data-testid="section-finalites">
            <h2 className="text-2xl mb-4 text-[#5C2018]" style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}>
              3. Finalités et bases légales
            </h2>
            <ul className="text-sm space-y-3 list-disc pl-6">
              <li>
                <strong>Répondre à vos demandes</strong> (contact, diagnostic, rendez-vous,
                événements) — <em>Base : exécution de mesures précontractuelles à votre demande.</em>
              </li>
              <li>
                <strong>Gérer la relation client</strong> et le suivi commercial —
                <em> Base : intérêt légitime de l'entreprise.</em>
              </li>
              <li>
                <strong>Modération et publication des avis</strong> — <em>Base : votre consentement explicite.</em>
              </li>
              <li>
                <strong>Sécurité du site et statistiques de fréquentation anonymisées</strong> —
                <em> Base : intérêt légitime.</em>
              </li>
            </ul>
          </section>

          {/* Conservation */}
          <section data-testid="section-conservation">
            <h2 className="text-2xl mb-4 text-[#5C2018]" style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}>
              4. Durée de conservation
            </h2>
            <ul className="text-sm space-y-2 list-disc pl-6">
              <li>Demandes via formulaires : <strong>3 ans</strong> à compter du dernier contact</li>
              <li>Données clients (factures, comptabilité) : <strong>10 ans</strong> (obligation légale)</li>
              <li>Avis publiés : conservés tant que vous ne demandez pas leur suppression</li>
              <li>Logs de connexion : <strong>13 mois maximum</strong></li>
            </ul>
          </section>

          {/* Destinataires */}
          <section data-testid="section-destinataires">
            <h2 className="text-2xl mb-4 text-[#5C2018]" style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}>
              5. Destinataires des données
            </h2>
            <p className="text-sm mb-3">
              Vos données sont strictement réservées à l'équipe de Harmony Parfumerie. Elles
              ne sont en aucun cas vendues, louées ou cédées à des tiers à des fins
              commerciales.
            </p>
            <p className="text-sm mb-3">
              Certains sous-traitants techniques peuvent traiter vos données pour notre
              compte, dans le strict respect du RGPD :
            </p>
            <ul className="text-sm space-y-2 list-disc pl-6">
              <li><strong>FormSubmit.co</strong> — acheminement des emails de formulaire</li>
              <li><strong>Square</strong> — gestion des paiements et de l&apos;abonnement mensuel</li>
              <li><strong>PayPal</strong> — paiements en ligne (alternative au CB)</li>
              <li><strong>Emergent Labs</strong> — hébergement sécurisé du site</li>
            </ul>
          </section>

          {/* Droits */}
          <section data-testid="section-droits">
            <h2 className="text-2xl mb-4 text-[#5C2018]" style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}>
              6. Vos droits
            </h2>
            <p className="text-sm mb-3">
              Conformément au RGPD, vous disposez à tout moment des droits suivants sur vos
              données :
            </p>
            <ul className="text-sm space-y-2 list-disc pl-6">
              <li><strong>Droit d'accès</strong> — obtenir une copie de vos données</li>
              <li><strong>Droit de rectification</strong> — corriger une donnée inexacte</li>
              <li><strong>Droit à l'effacement</strong> (« droit à l'oubli »)</li>
              <li><strong>Droit à la limitation</strong> du traitement</li>
              <li><strong>Droit à la portabilité</strong> de vos données</li>
              <li><strong>Droit d'opposition</strong> au traitement</li>
              <li><strong>Droit de retirer votre consentement</strong> à tout moment</li>
            </ul>
            <p className="text-sm mt-4">
              Pour exercer ces droits, contactez-nous à{' '}
              <a href="mailto:contact@maisonharmony.com" className="text-[#1E7A6A] hover:underline">
                contact@maisonharmony.com
              </a>{' '}
              en précisant votre demande. Une réponse vous sera apportée dans un délai d'un
              mois.
            </p>
            <p className="text-sm mt-3">
              Si vous estimez, après nous avoir contactés, que vos droits ne sont pas
              respectés, vous pouvez adresser une réclamation à la{' '}
              <a
                href="https://www.cnil.fr"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#1E7A6A] hover:underline"
              >
                CNIL
              </a>{' '}
              (Commission Nationale de l'Informatique et des Libertés).
            </p>
          </section>

          {/* Cookies */}
          <section data-testid="section-cookies">
            <h2 className="text-2xl mb-4 text-[#5C2018]" style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}>
              7. Cookies et traceurs
            </h2>
            <p className="text-sm mb-3">
              Notre site utilise uniquement des cookies strictement nécessaires à son bon
              fonctionnement (session, sécurité). Aucun cookie publicitaire ou de profilage
              tiers n'est déposé sans votre consentement explicite.
            </p>
            <p className="text-sm">
              Vous pouvez à tout moment paramétrer votre navigateur pour refuser les cookies
              ou être averti avant qu'ils ne soient déposés.
            </p>
          </section>

          {/* Sécurité */}
          <section data-testid="section-securite">
            <h2 className="text-2xl mb-4 text-[#5C2018]" style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}>
              8. Sécurité
            </h2>
            <p className="text-sm">
              Harmony Parfumerie met en œuvre toutes les mesures techniques et
              organisationnelles raisonnables pour protéger vos données contre la perte, le
              vol, l'accès non autorisé, la divulgation ou la modification : connexion HTTPS,
              base de données sécurisée, accès restreint aux personnes habilitées.
            </p>
          </section>

          {/* Modification */}
          <section data-testid="section-modification">
            <h2 className="text-2xl mb-4 text-[#5C2018]" style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic' }}>
              9. Modification de la politique
            </h2>
            <p className="text-sm">
              La présente politique peut être amenée à évoluer. Toute modification sera
              publiée sur cette page avec une nouvelle date de mise à jour.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default ConfidentialitePage;
